import firebase from 'firebase' 

/* const firebaseConfig = {
    apiKey: "AIzaSyDwPa_KBniL-LLdDdQkUXWW81xJFpkqMzc",
    authDomain: "neary-somrosthomcheat.firebaseapp.com",
    projectId: "neary-somrosthomcheat",
    storageBucket: "neary-somrosthomcheat.appspot.com",
    messagingSenderId: "1017083083214",
    appId: "1:1017083083214:web:3930fcfda8788b3186d39f",
    measurementId: "G-3971LWVTTX"
}; */

const firebaseConfig = {
    apiKey: "AIzaSyAAqZGGejSgQTUMpl5K1oh8V7KkigsMAyU",
    authDomain: "one-store-c3e30.firebaseapp.com",
    databaseURL: "https://one-store-c3e30-default-rtdb.firebaseio.com",
    projectId: "one-store-c3e30",
    storageBucket: "one-store-c3e30.appspot.com",
    messagingSenderId: "553899521245",
    appId: "1:553899521245:web:5ddae571027e4b34de5734",
    measurementId: "G-XERP4TV1MB"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
//require("firebase/firestore");

//export const db = firebase.firestore();
export const db = firebase.database();